
import Vue from 'vue';
import { BContainer, BRow, BCol, BNavbarNav, BNavItem } from 'bootstrap-vue';
export default Vue.extend({
	components: {
		BContainer,
		BRow,
		BCol,
		BNavbarNav,
		BNavItem
	},
	props: {
		backgroundImageSource: {
			type: String,
			required: false,
			default: null
		}
	},
	computed: {
		backgroundClass: function() {
			if (this.backgroundImageSource) return 'bg-image';
			return 'bg-gradient-primary-75';
		},
		backgroundImageStyle: function() {
			if (this.backgroundImageSource) return 'background-image: url(' + this.backgroundImageSource + ');';
			return '';
		}
	}
});
